<template>
  <div class="text-center">
    <v-dialog v-model="showModal" content-class="v-dialog--custom dialog-promotions">
      <div class="card border-0 modal-promotions">
        <div class="card-body p-0 d-flex h-100">
          <div class="col-12 col-md-6 p-5 h-100">
            <button @click="closeModal" class="mb-2 w-100 d-md-none" style="cursor:pointer;">
              <i class="fas fa-times-circle fa-lg float-right"></i>
            </button>
            <h3 class="font-weight-bold color-palette-4">Promociones {{ project.name }}</h3>
            <div class="mt-5 d-flex flex-column" style="gap: 10px;">
              <span v-for="(promotion) in project.promotions">
                <i class="fas fa-check color-palette-4"></i>
                <span v-html="promotion"></span>
              </span>
            </div>
          </div>
          <div class="d-none d-md-block w-100">
            <span @click="closeModal" class="p-2 position-absolute" style="cursor:pointer; right: 0;">
              <i class="fas fa-times-circle fa-lg"></i>
            </span>
            <img class="w-100 h-100" src="/assets/images/modal/familia_promociones.webp" alt="img-modal-home">
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "modalPromotions",
  props: {
    showModal: {
      required: true,
      default: false
    },
    project: Object
  },
  data: () => ({
    show: false,
  }),
  mounted() {
    document.addEventListener('keydown', this.handleEsc);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEsc);
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  },

  computed: {
  },
  watch: {
  },
  validations: {
  }
};
</script>

<style scoped>
.letter-small {
  font-size: 0.8rem !important;
}

input {
  height: 2rem !important;
  border-radius: 9px !important;
}

@media (max-width: 639px) {}
</style>